import ABCyaLib from "@abcya/abcya_lib";
import { Images, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import UIAssetKeys from "../UIAssetKeys";
import Hammer from "./Hammer";
import NounVerbs from "./NounVerbs";

export default class Gator extends Phaser.GameObjects.Container
{
	constructor(scene, type, ind, txt)
	{
		super(scene, gameData.gatorLocs[ind].x, gameData.gatorLocs[ind].y);
		this.type = type;
		this.ind = ind;
		this.txt = txt;

		this.color = null;
		this.active = false;
		this.torso = null;
		this.jaw = null;
		this.head = null;
		this.eye1 = null;
		this.eye2 = null;

		this.headCont = null;
		this.jawCont = null;
		this.gatorCont = null;
		this.signCont = null;

		this.text = null;
		this.sign = null;

		this.sewer = null;
		this.masker = null;

		this.tween1 = null;
		this.tween2 = null;
		this.tween3 = null;
		this.tween4 = null;
		this.eyeTween = null;
		this.eyeTween2 = null;

		this.isCorrect = false;
		this.verbType = false;
		this.isHiding = false;

		this.timer = null;

		this.createGator();

		if(gameData.currentScene === "playScene" && !gameData.gamePaused || gameData.currentScene === "TutorialScene" && !gameData.gamePaused) {
			this.setBelow();
			this.createText();
		} else if(gameData.currentScene === "playScene" && gameData.gamePaused) {
			//this.idle();
			if(this.txt) this.createText(this.txt);
		} else {
			//this.idle();
			this.createText((ABCyaLib.Environment.instance.locale !== 'en-AU' && ABCyaLib.Environment.instance.locale !== 'en-GB') ? "howdy" : "hey");
		}
	}

	createGator(isReset) {
		this.headCont = this.scene.add.container();
		this.jawCont = this.scene.add.container();
		this.signCont = this.scene.add.container();
		this.gatorCont = this.scene.add.container();

		if(gameData.currentScene === "playScene" && !gameData.gamePaused || gameData.currentScene === "TutorialScene" && !gameData.gamePaused) {
			this.color = 1 + Math.floor(Math.random() * 4);

			this.sewer = Images.addImage(48, 102, UIAssetKeys._SewerHole, this);
		}
		else if(gameData.currentScene === "playScene" && gameData.gamePaused) {
			this.color = 1;

			if(isReset){
			
				this.sewer = Images.addImage(48, 102, UIAssetKeys._SewerHole, this);
			}
		}
		else {
			this.color = 1;
		}

		this.torso = Images.addImage(0, 0, `Torso${this.color}`, this.gatorCont);
		this.head = Images.addImage(0, 0, `Head${this.color}`, this.headCont);
		this.jaw = Images.addImage(0, 0, `LowerJaw${this.color}`, this.jawCont);
		this.eye1 = Images.addImage(0, 0, `ClosedEyes${this.color}`, this.headCont);
		this.eye2 = Images.addImage(0, 0, `eyeClosed${this.color}`, this.headCont);

		this.add(this.gatorCont);
		this.gatorCont.add(this.headCont);
		this.headCont.add(this.jawCont);
		this.jawCont.add(this.signCont);

		if(gameData.currentScene === "playScene" && !gameData.gamePaused || gameData.currentScene === "TutorialScene" && !gameData.gamePaused) {
			this.masker = Images.addImage(this.sewer.x, this.sewer.y + 20, UIAssetKeys._sewerMask, this);
			this.masker.setOrigin(.5, 0);
		}
		else if(gameData.currentScene === "playScene" && gameData.gamePaused && isReset){
			this.masker = Images.addImage(this.sewer.x, this.sewer.y + 20, UIAssetKeys._sewerMask, this);
			this.masker.setOrigin(.5, 0);
		}

		this.torso.setOrigin(.2, .1);
		this.head.setOrigin(.1, .2);
		this.jaw.setOrigin(.1, .5);
		this.eye1.setOrigin(.5, 0);
		this.eye2.setOrigin(.5, 0);

		this.eye1.scaleY = 0;
		this.eye2.scaleY = 0;

		this.headCont.setPosition(0, 20);
		this.head.setPosition(20, -50);
		this.jawCont.setPosition(64, 10);
		this.eye1.setPosition(75, -59);
		this.eye2.setPosition(25, -57);

		if(this.type === "left" && !isReset){
			this.scaleX *=-1;
		}

		if(isReset){
			this.setBelow();

			this.isHiding = true;
			this.createText();
		}

		this.blink();
	};

	setBelow(){
		this.gatorCont.setAlpha(0);
		this.headCont.angle = -50;
		this.headCont.setPosition(8, 60);
		this.signCont.angle = 50;
		this.gatorCont.y = 320;
	};

	createText(word){
		this.sign = Images.addImage(0, 0, UIAssetKeys._sign, this.signCont);
		this.sign.setOrigin(.5, 0);
		this.signCont.setPosition(110, -40);

		if(word) {
			this.text = this.scene.add.bitmapText(0, 60, 'font1', word, 26, this.signCont);
			this.signCont.add(this.text);
			this.signCont.setScale(.9, .9);
		} else {
			this.text = this.scene.add.bitmapText(0, 60, 'font1', this.chooseVerb(), 26, this.signCont);
			this.signCont.add(this.text);
			this.signCont.setScale(1.2, 1,2);
		}

		this.text.setOrigin(.5,.5);
		this.text.tint = "0x000000";

		if(this.type === "left") {
			this.text.scaleX *=-1;
		}
	};

	blink(){
		//console.log("blinking");
		const randDel = 1000 + Math.floor(Math.random() * 3000);
		this.eyeTween = Tweens.addTween([this.eye1,this.eye2], 340, {scale:{start: 0, to: 1}, delay: randDel, loop: -1, loopDelay: randDel, onLoop:()=>{this.eyeTween.loopDelay = 1000 + Math.floor(Math.random() * 3000)}}, Phaser.Math.Easing.Quadratic.InOut)
	};

	idle(){
		if(this.gatorCont.y >= 0)
		{
			this.isHiding = false;

			if(gameData.currentScene === "playScene" && !gameData.gamePaused || gameData.currentScene === "TutorialScene" && !gameData.gamePaused) {
				if(gameData.score < 10) {
					//console.log("enabling");
					this.enableInput();
				}
			}

			this.tween2 = Tweens.addTween(this.jawCont, 2000, {angle: {start: 0, to: 5, delay: 1000}, repeat: -1, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
			this.tween3 = Tweens.addTween(this.headCont, 3000, {angle: {start: 0, to: 10}, repeat: -1, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
			this.tween4 = Tweens.addTween(this.signCont, 2000, {angle: {start: 0, to: -20}, repeat: -1, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
		}
	};

	enableInput(){
		//console.log("enabling gator input");
		if(!gameData.gameOver){
			this.torso.setInteractive();
			this.head.setInteractive();
			this.jaw.setInteractive();
			this.sign.setInteractive();

			this.torso.on('pointerdown', ()=>this.whamBam());
			this.head.on('pointerdown', ()=>this.whamBam());
			this.jaw.on('pointerdown', ()=>this.whamBam());
			this.sign.on('pointerdown', ()=>this.whamBam());
		}
	};

	
	whamBam(){
		//console.log("THANK YOU MA'AM", this.isCorrect);
		this.disableInput();

		if(gameData.currentScene !== "TutorialScene"){
			this.hammer = new Hammer(this.scene, this.type, this.ind, this);
			this.scene.add.existing(this.hammer);
		} else {
			this.hammer = new Hammer(this.scene, this.type, this.isCorrect, this);
			this.scene.add.existing(this.hammer);
		}
	};

	chooseVerb(type){
		let verbInd;
		let randVerb;

		if(gameData.currentScene === "TutorialScene"){
			if(this.ind === 0){
				verbInd = Math.floor(Math.random() * NounVerbs.pluralVerbs.length);
				randVerb = NounVerbs.pluralVerbs[verbInd];
				this.verbType = "plural";
			} else {
				verbInd = Math.floor(Math.random() * NounVerbs.singleVerbs.length);
				randVerb = NounVerbs.singleVerbs[verbInd];
				this.verbType = "singular";
			}
		}
		else {
			if(type === "plural"){
				verbInd = Math.floor(Math.random() * NounVerbs.pluralVerbs.length);
				randVerb = NounVerbs.pluralVerbs[verbInd];
			} else {
				verbInd = Math.floor(Math.random() * NounVerbs.singleVerbs.length);
				randVerb = NounVerbs.singleVerbs[verbInd];
			}
			this.verbType = type;
		}

		return randVerb;
	};

	changeText(type){
		this.text.text = this.chooseVerb(type);
	};

	disableInput(){
		//console.log("disabling input");
		this.torso.disableInteractive();
		this.head.disableInteractive();
		this.jaw.disableInteractive();
		this.sign.disableInteractive();
	};

	burstOut(noDelay){
		if(!gameData.gamePaused) this.disableInput();

		this.setBelow();

		this.isHiding = true;

		let randDel;
		if(noDelay) {
			randDel = 0;
		} else {
			randDel = Math.floor(Math.random() * 3000);
		}

		// this.scene.tweens.killTweensOf(this.gatorCont.list);
		// this.scene.tweens.killTweensOf(this.headCont.list);
		// this.scene.tweens.killTweensOf(this.signCont.list);
		// this.scene.tweens.killTweensOf(this.gatorCont);
		// this.scene.tweens.killTweensOf(this.headCont);
		// this.scene.tweens.killTweensOf(this.signCont);

		// this.headCont.angle = -50;
		// this.headCont.setPosition(8, 60);
		// this.sign.alpha = 0
		// this.signCont.angle = 70;

		this.tween1 = Tweens.addTween(this.gatorCont, 1000, {y:0, delay: randDel}, Phaser.Math.Easing.Quadratic.Out);
		this.tween2 = Tweens.addTween(this.headCont, 600, {angle: {start: -50, to: 0}, y: 20, x: 0, delay: randDel + 400}, Phaser.Math.Easing.Quadratic.Out);
		this.tween3 = Tweens.addTween(this.signCont, 600, {angle: 0, alpha: 1, delay: randDel + 400}, Phaser.Math.Easing.Quadratic.Out);
		this.tween4 = Tweens.addTween(this.gatorCont, 600, {alpha: 1}, Phaser.Math.Easing.None);

		this.tween1.on('complete', this.idle, this);
		this.tween1.on('start', ()=>{
			this.sign.alpha = 1;
		})

		if(gameData.currentScene !== "TutorialScene"){
			let levelAdj;
			if(gameData.currentLevel < 3) {
				levelAdj = 7000;
			} else if(gameData.currentLevel >= 3 && gameData.currentLevel < 5) {
				levelAdj = 5000;
			} else {
				levelAdj = 3000;
			}

			if(this.isCorrect){
				this.timer = this.scene.time.addEvent({
					delay: randDel + levelAdj + (5000),                
					callback: ()=>this.scene.allHide(),

				});
			} else {
				this.timer = this.scene.time.addEvent({
					delay: randDel + levelAdj + (5000),                
					callback: ()=>this.hide(),
				});
			}
		}
	};

	compareAnswer(){
		//console.log(gameData.nounType, this.verbType);
		if(gameData.nounType === this.verbType) {
			this.isCorrect = true;
		} else {
			this.isCorrect =  false;
		}

		return this.isCorrect;
	};

	gatorReact(isGood){
		//console.log("OUCH");
		this.disableEvents();
		this.disableInput();

		if(isGood){
			this.scene.navBar.updateScore(1);

			this.tween2 = Tweens.addTween(this.headCont, 250, {angle:-40, yoyo: true}, Phaser.Math.Easing.Quadratic.Out);
			this.tween3 = Tweens.addTween(this.jawCont, 250, {angle:40, yoyo: true}, Phaser.Math.Easing.Quadratic.Out);
			this.tween4 = Tweens.addTween(this.signCont, 250, {angle:40, yoyo: true}, Phaser.Math.Easing.Quadratic.Out, 
				()=>{this.scene.allHide()});
		} else {
			if(gameData.currentLevel >= 3) this.scene.navBar.updateScore(-1);

			this.tween2 = Tweens.addTween(this.gatorCont, 300, {y:420}, Phaser.Math.Easing.Quadratic.Out);
			this.tween3 = Tweens.addTween(this.headCont, 100, {angle:-50, y:60, x:5}, Phaser.Math.Easing.Quadratic.Out);
			this.tween4 = Tweens.addTween(this.signCont, 100, {angle:50}, Phaser.Math.Easing.Quadratic.Out,
				()=>this.fastEnter());
		}
	};

	hide(){
		//console.log("HIDING");
		this.disableEvents();
		this.disableInput();

		this.scene.tweens.killTweensOf(this.gatorCont.list);

		this.liftHead(true);

		this.isHiding = true;

		this.tween1 = Tweens.addTween(this.gatorCont, 750, {y:320, delay: 500}, Phaser.Math.Easing.Quadratic.In, ()=>{this.gatorCont.alpha = 0; this.newGator()});
		Tweens.addTween(this.gatorCont, 150, {alpha:0, delay: 1000});
	};

	liftHead(delay){
		let del;
		if(delay) {
			del = 200;
		} else {
			del = 0
		}

		this.tween1 = Tweens.addTween(this.headCont, 1000, {angle:-50, y:60, x:5, delay: del}, Phaser.Math.Easing.Quadratic.Out);
        this.tween2 = Tweens.addTween(this.signCont, 1000, {angle:50, delay: del}, Phaser.Math.Easing.Quadratic.Out);
	};

	fastEnter(){
		this.tween1 = Tweens.addTween(this.gatorCont, 500, {y:0}, Phaser.Math.Easing.Quadratic.Out, ()=>{
			this.laugh();
			this.idle();
		});
		this.tween2 = Tweens.addTween(this.headCont, 300, {angle:0, y:20, x:0, delay: 200}, Phaser.Math.Easing.Quadratic.Out);
		this.tween3 = Tweens.addTween(this.signCont, 300, {angle:0, delay: 200}, Phaser.Math.Easing.Quadratic.Out);
		this.tween4 = Tweens.addTween(this.gatorCont, 500, {alpha:1}, Phaser.Math.Easing.None);

		// console.log('fast enter')
	};

	newGator(){
		if(this.hammer){
			this.hammer.cleanUp();
			this.hammer.destroy();
			this.hammer = null;
		}

		this.scene.activeGators.splice(this.scene.activeGators.indexOf(this), 1);
		this.scene.gators.push(this);

		this.cleanUp();
		this.createGator(true);

		if(gameData.currentScene !== "TutorialScene") {
			if(gameData.score < gameData.questions && !gameData.gameOver) this.scene.newGator();
		}
		else {
			if(this.ind !== 0){
				//console.log("completed tutorial");
				this.scene.cleanUp();
			}
		}
	};

	disableEvents(){

		this.scene.tweens.killTweensOf(this.gatorCont.list);
		this.scene.tweens.killTweensOf(this.gatorCont);
		//this.scene.tweens.killTweensOf(this.)

		if(this.timer) {
			this.scene.time.removeEvent(this.timer);
			this.timer = null;
		}
	};

	cleanUp(){
		this.disableInput();
		this.disableEvents();

		if(this.hammer){
			this.hammer.cleanUp();
			this.hammer.destroy();
			this.hammer = null;
		}

		this.eye1.destroy();
		this.eye2.destroy();
		this.torso.destroy();
		this.jaw.destroy();
		this.head.destroy();
		if(this.sign) this.sign.destroy();
		if(this.masker) this.masker.destroy();
		if(this.sewer) this.sewer.destroy();
		this.text.destroy();

		this.headCont.destroy();
		this.jawCont.destroy();
		this.signCont.destroy();
		this.gatorCont.destroy();

		//this.destroy();
	};

	laugh(){
		this.tween1 = Tweens.addTween(this.gatorCont, 110, {y:25, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut, 
			()=>this.hide());
		this.tween2 = Tweens.addTween(this.headCont, 100, {angle:-20, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
		this.tween3 = Tweens.addTween(this.jawCont, 100, {angle:40, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
		this.tween4 = Tweens.addTween(this.signCont, 100, {angle:50, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
	};
}